
import { Modal } from '../ui_new'
import { Send } from '@material-ui/icons'
import { AddComment, Close } from '../../assets/icons'
import { Cancel } from '@mui/icons-material'

const SingleDocumentSuggestionModal = ({ onClose, onSubmit, children, variable }) => {

  return (
    <Modal onClose={onClose} className="modal-v2 modal-v2--mid">
      <div className='modal-v2__heading modal-v2__heading--nowrap'>
        <div>
          <h2>Proposition de modification</h2>
        </div>
        <div className="buttons-row">
          <button className='button button--with-icon button--transparent btn--medium' onClick={onClose}><span className='icon'><Close /></span>Fermer</button>
          <button className='button button--with-icon button--primary-light btn--medium desktop' onClick={onSubmit}><span className='icon'><Send /></span>Envoyer</button>
        </div>
      </div>
      <div className='modal-v2__body pb-4'>
        <div className="my-2">
          <h3 className="!comments__section-title">{variable?.display_name}</h3>
        </div>
        <div className='variables-v2 opened'>
          <div className="variables-v2__body variables-v2__body--suggestion">
            {children}
          </div>
        </div>
        <div className="modal-v2__buttons-footer mobile">
          <button className='btn btn--primary-light btn--large btn--with-icon w-full' onClick={onSubmit}><span className='icon'><AddComment /></span>Envoyer</button>
        </div>
      </div>
    </Modal>
  )
}

export default SingleDocumentSuggestionModal
